import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TimerIcon from '@material-ui/icons/TimerSharp';

const useStyles = makeStyles((theme) => ({
 processingIcon: {
  color: theme.palette.secondary.light,
  width: '20px',
  height: '20px',
 },
}));

export default function ProcessingIcon() {
  const classes = useStyles();
  return (
    <TimerIcon className={classes.processingIcon} />
  );
}
